module.exports = __webpack_public_path__ + "static/media/img42.98cc8bfa.jpg";